/**
 * Post-response scoping for reporting list APIs (GetTemplatesMulty / GetMacrosMulty).
 * Callers that omit related-user fields receive the payload unchanged (e.g. Home page).
 */

function isDefaultTemplate(row) {
  return (row?.isDefault ?? row?.IsDefault) === true;
}

function createdById(row) {
  const id = row?.createdBy ?? row?.CreatedBy;
  return id == null ? null : id;
}

/**
 * Templates: default/system templates plus any created by the related user.
 * If relatedUserId is not provided, returns payload unchanged.
 *
 * @param {unknown} payload - API payload (expected array)
 * @param {string|null|undefined} relatedUserId
 * @returns {unknown}
 */
export function applyTemplateScopeForRelatedUser(payload, relatedUserId) {
  if (!Array.isArray(payload)) return payload;
  if (relatedUserId == null || relatedUserId === "") {
    return payload;
  }
  return payload.filter((row) => {
    if (isDefaultTemplate(row)) return true;
    const id = createdById(row);
    return id != null && id === relatedUserId;
  });
}

/**
 * Patient sidebar macros: only macros owned by the related user.
 *
 * @param {unknown} payload - API payload (expected array)
 * @param {string|null|undefined} relatedUserId
 * @returns {unknown}
 */
export function applyMacroScopeForRelatedUser(payload, relatedUserId) {
  if (!Array.isArray(payload)) return payload;
  if (relatedUserId == null || relatedUserId === "") {
    return payload;
  }
  return payload.filter((row) => createdById(row) === relatedUserId);
}
